import { Stack, Typography } from '@mui/material'
import { VesselArea } from '@operations/app/api'
import { convertOperationType } from '@operations/utils/helper'
import { useTranslate } from '@tolgee/react'
import { TomTableEmptyCell } from '@tom-ui/ui'
import { formatDateRange } from '@tom-ui/utils'
import _ from 'lodash'
import { observer } from 'mobx-react-lite'
import { WorkInstructionViewModel } from '../../models/work-instruction-view.model'

interface Props {
  workInstruction: WorkInstructionViewModel
}
export const WorkInstructionWorkQueueCell = observer(({ workInstruction }: Props) => {
  const { t } = useTranslate()

  if (workInstruction.workQueueName)
    return <Typography variant='body2'>{workInstruction.workQueueName}</Typography>

  if (!workInstruction.workQueueFromTime || !workInstruction.workQueueToTime)
    return <TomTableEmptyCell renderedCellValue={undefined} />

  return (
    <Stack>
      <Typography variant='captionBold'>
        {`${t(convertOperationType(workInstruction.operationType, workInstruction.carrierType))} - ${workInstruction.craneName} `}
      </Typography>
      <Typography variant='caption'>
        {formatDateRange(workInstruction.workQueueFromTime, workInstruction.workQueueToTime)}
      </Typography>
      <Typography variant='caption'>
        {`${!workInstruction.bay ? t('unknownBay', 'Unknown bay') : t('bay', 'Bay') + ' ' + workInstruction.bay} - ${t(_.lowerFirst(workInstruction.vesselArea ?? VesselArea.Hold))}`}
      </Typography>
    </Stack>
  )
})
